import { ItemType } from '../../api/useEstatePlanningFlowQuery';

// Styles Variants
export type VariantProps =
  | 'principal'
  | 'spouse'
  | 'beneficiaries'
  | 'taxesAndFees'
  | 'charityBeneficiaries'
  | 'neutral';

export const VARIANT_MAP = {
  [ItemType.Principal]: 'principal',
  [ItemType.Spouse]: 'spouse',
  [ItemType.CharityBeneficiaries]: 'charityBeneficiaries',
  [ItemType.Beneficiaries]: 'beneficiaries',
  [ItemType.TaxesAndFees]: 'taxesAndFees',
};
